export default __webpack_public_path__ + "static/media/cross.92e7b1fd.svg";